import React from "react";
import { createRoot } from "react-dom/client";
import MainApp from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}
const root = createRoot(container);
root.render(<MainApp />);
